import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2, UserPlus } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../ui/collapsible";
import { api, errMsg } from "../../lib/api";

export const PpcMembers = ({ onChange }) => {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ name: "", email: "", position: "" });
  const load = useCallback(() => api.get("/ppc/members").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/ppc/members", f); setF({ name: "", email: "", position: "" }); toast.success("Added to the PPC list"); load(); onChange?.(); } catch (er) { toast.error(errMsg(er)); }
  };
  const del = async (id) => { try { await api.delete(`/ppc/members/${id}`); load(); onChange?.(); } catch (er) { toast.error(errMsg(er)); } };
  return (
    <Collapsible className="rounded-xl border border-amber-700/15 bg-white p-4" data-testid="ppc-members">
      <CollapsibleTrigger className="flex w-full items-center justify-between text-left" data-testid="ppc-members-toggle">
        <span className="flex items-center gap-2 font-semibold text-stone-800"><Mail className="h-4 w-4 text-amber-900" />PPC email list</span>
        <span className="text-xs text-stone-500" data-testid="ppc-members-count">{list.length} member{list.length === 1 ? "" : "s"} · tap to manage</span>
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-4 space-y-3">
        <form onSubmit={add} className="grid gap-2 sm:grid-cols-[1fr_1fr_1fr_auto]">
          <Input required placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="ppc-member-name-input" />
          <Input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="ppc-member-email-input" />
          <Input placeholder="Position (optional)" value={f.position} onChange={(e) => setF({ ...f, position: e.target.value })} data-testid="ppc-member-position-input" />
          <Button type="submit" variant="outline" data-testid="ppc-member-add-button"><UserPlus className="h-4 w-4 mr-1" />Add</Button>
        </form>
        <ul className="divide-y divide-stone-100 text-sm">
          {list.map((m) => (
            <li key={m.member_id} className="flex items-center justify-between py-2" data-testid={`ppc-member-${m.member_id}`}>
              <span><span className="font-medium text-stone-800">{m.name}</span>{m.position && <span className="text-stone-500"> · {m.position}</span>}<span className="block text-xs text-stone-500">{m.email}</span></span>
              <Button size="sm" variant="ghost" onClick={() => del(m.member_id)} data-testid={`ppc-member-remove-${m.member_id}`}><Trash2 className="h-4 w-4" /></Button>
            </li>
          ))}
          {!list.length && <li className="py-2 text-stone-500">No members yet. Only people on this list receive the PPC summary email.</li>}
        </ul>
      </CollapsibleContent>
    </Collapsible>
  );
};
